import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import ManagePoiAddInternalLink from '../components/PointOfInterest/ManagePoiAddInternalLink'
import ManagePoiInternalLinksList from '../components/PointOfInterest/ManagePoiInternalLinksList'
import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'
import config from '../config/config'
import PoiTechnicalSheet from '../components/PointOfInterest/PoiTechnicalSheet'
import ManagePoiNavBar from '../components/PointOfInterest/ManagePoiNavBar'
import { getPoiLabel } from '../utils/utils'
import { setFlashMessage } from '../contexts/WebsiteContext'

const ManagePoiInternalLinks = () => {
  const { t } = useTranslation()
  const [refreshList, setRefreshList] = useState(false)
  const [poi, setPoi] = useState(null)
  const { id } = useParams()

  useEffect(() => {
    const fetchPoi = async () => {
      try {
        const response = await axios.get(`${config.apiUrl}poi/${id}`)
        setPoi(response.data)
      } catch (error) {
        // console.error('An error occurred:', error);
        setFlashMessage(t('ERROR_MESSAGE'), 'error')
      }
    }

    fetchPoi()
  }, [id, t])

  const handleAddLink = () => {
    setRefreshList(!refreshList)
  }

  return (
    <div style={{ margin: '0 10px' }}>
      <NavigationBar />
      <h1>
        {t('MANAGE_INTERNAL_LINKS')} - {getPoiLabel(poi)}
      </h1>
      <ManagePoiNavBar />
      {poi && <PoiTechnicalSheet poi={poi} />}
      {poi && (
        <ManagePoiAddInternalLink poi={poi} handleAddLink={handleAddLink} />
      )}
      {poi && (
        <ManagePoiInternalLinksList poi={poi} refreshList={refreshList} />
      )}
      <Footer />
    </div>
  )
}

export default ManagePoiInternalLinks
